import { render, staticRenderFns } from "./JoinOvadraft.vue?vue&type=template&id=6a586775&scoped=true&"
import script from "./JoinOvadraft.vue?vue&type=script&lang=js&"
export * from "./JoinOvadraft.vue?vue&type=script&lang=js&"
import style0 from "./JoinOvadraft.vue?vue&type=style&index=0&id=6a586775&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a586775",
  null
  
)

export default component.exports